/* unplugin-vue-components disabled */import script from "./PropsTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropsTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PropsTableBlock.vue?vue&type=style&index=0&id=17ab85fb&scoped=true&lang=less"
import "./PropsTableBlock.vue?vue&type=style&index=1&id=17ab85fb&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ab85fb"]])

export default __exports__